/**
 * This function will iterate the target enum to search for the value & returns the corresponding enum key
 * Ex: enum Test {
 *  First: "1st",
 *  Second: "2nd"
 * }
 * reverseLookupEnum(Test, "1st") => Test.First
 * @param targetEnum enum where to lookup for key
 * @param enumValue value for which reverse enum key is needed
 */
export function reverseLookupEnum<E extends Record<keyof E, string | number>>(
  targetEnum: E,
  enumValue: string | undefined
): E[keyof E] | undefined {
  type targetEnumKeyType = keyof typeof targetEnum;
  const keys = Object.keys(targetEnum)
    .filter((key: targetEnumKeyType) => targetEnum[key] === enumValue)
    .map((key: targetEnumKeyType) => targetEnum[key]);
  return keys.length > 0 ? keys[0] : undefined;
}
